import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_email_request_attachments_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { requestId: string, $top?: number, $skip?: number }): Promise<{ result?: { attachmentId?: string, fileName?: string, fileType?: string }[], totalCount?: number }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.requestId)) {
      $missingRequiredInParams.push('\'requestId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { requestId?: string, $keys: string[] }): Promise<{ result?: { attachmentId?: string, fileName?: string, fileType?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      requestId: string    }) {
        if(isNil($inParams.requestId)) {
          return true; 
        }
      return false;
    }
}
